import { LOCALE_CHANGED, SERVER_PROFILES_CHANGED } from '../../constants'
import {
    actionLoggerLog,
    actionAppSetAutoLaunchEnabledState,
    setClientLauncherToken,
} from '../../actions'
import getAttributesImport from '../../settings/attributes'
import getServicesImport from '../../settings/services'
import { selectors as backendSelectors } from '../Backend'
import { selectors as settingsSelectors } from '../Settings'
import LaunchProgressBarImport, {
    selectors as launchProgressBarSelectors,
    actions as launchProgressBarActions,
} from '../LaunchProgressBar'
import { actions as toasterActions } from '../Toaster'
import { actions as profileSelectorActions } from '../ProfileSelector'
import { selectors as eulaSelectors, actions as eulaActions } from '../Eula'

export { launcherQuitProcess, launcherLaunchEve } from '../../launcherBackend/launcher-command'

export const LaunchProgressBar = LaunchProgressBarImport

export { default as Button } from '../../components/Button'
export { default as Tooltip } from '../../containers/Tooltip'

export { default as getTexts } from '../../store/localizer'

export const getAttributes = (locale) => {
    const attributes = getAttributesImport(locale)
    const services = getServicesImport(locale)
    return {
        pressDelayMilliseconds: attributes.userList.pressDelayMilliseconds,
        slingerRefresh: services.token_service.refresh,
        clientTokenUrl: attributes.service.sso.clientToken,
        thirdPartyLogin: attributes.service.thirdPartyLogin,
    }
}

export const constants = {
    LOCALE_CHANGED,
    SERVER_PROFILES_CHANGED,
}

export const actions = {
    log: actionLoggerLog,
    disableAutoRun: () => actionAppSetAutoLaunchEnabledState(false),
    setClientLaunchProgress: (serverId, userId, progress) =>
        launchProgressBarActions.setLaunchProgress(serverId, userId, progress),
    toggleSelector: (userId, title, boundingRectangle) =>
        profileSelectorActions.toggleSelector(userId, title, boundingRectangle),
    addError: message => toasterActions.addError(message),
    showEulaPrompt: (userId, hash, accepted) => eulaActions.showEulaPrompt(userId, hash, accepted),
    setClientLauncherToken: (serverId, userId, profile, token) =>
        setClientLauncherToken(serverId, userId, profile, token),
}

export const selectors = {
    getLocale: state => backendSelectors.getLocale(state),
    isPlaying: (state, userId) => backendSelectors.isPlaying(state, userId),
    getActiveServer: state => backendSelectors.getActiveServer(state),
    getActiveServerId: state => backendSelectors.getActiveServerId(state),
    getActivePlayable: state => backendSelectors.getActivePlayable(state),
    getActiveRunningProcesses: state => backendSelectors.getActiveRunningProcesses(state),
    getActiveRunningLaunchProgresses: state =>
        launchProgressBarSelectors.getActiveRunningLaunchProgresses(state),
    getActiveLaunchProgress: (state, userId) =>
        launchProgressBarSelectors.getActiveLaunchProgress(state, userId),
    getAutoLaunchOnStartup: state => settingsSelectors.getAutoLaunchOnStartup(state),
    getLaunchDelay: state => settingsSelectors.getLaunchDelay(state),
    getLayout: state => settingsSelectors.getLayout(state),
    getEulaStatus: state => eulaSelectors.getStatus(state),
    getDeviceId: state => backendSelectors.getDeviceId(state),
}



// WEBPACK FOOTER //
// ./src/features/Users/imports.js